var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import * as React from 'react';
import AvatarImage from './AvatarImage';
import AvatarInitials from './AvatarInitials';
import UnknownUserAvatar from '../../icons/avatars/UnknownUserAvatar';

import './Avatar.scss';

var Avatar = function (_React$PureComponent) {
    _inherits(Avatar, _React$PureComponent);

    function Avatar() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Avatar);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Avatar.__proto__ || Object.getPrototypeOf(Avatar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            hasImageErrored: false
        }, _this.onImageError = function () {
            _this.setState({
                hasImageErrored: true
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Avatar, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.state.hasImageErrored && this.props.avatarUrl !== nextProps.avatarUrl) {
                this.setState({
                    hasImageErrored: false
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                avatarUrl = _props.avatarUrl,
                _props$className = _props.className,
                className = _props$className === undefined ? '' : _props$className,
                name = _props.name,
                id = _props.id;
            var hasImageErrored = this.state.hasImageErrored;


            var avatar = void 0;
            if (avatarUrl && !hasImageErrored) {
                avatar = React.createElement(AvatarImage, { url: avatarUrl, onError: this.onImageError });
            } else if (name) {
                avatar = React.createElement(AvatarInitials, { id: id, name: name });
            } else {
                avatar = React.createElement(UnknownUserAvatar, { className: 'avatar-icon' });
            }

            return React.createElement(
                'span',
                { className: 'avatar ' + className, role: 'presentation' },
                avatar
            );
        }
    }]);

    return Avatar;
}(React.PureComponent);

Avatar.propTypes = {
    /**
     * Url to avatar image.  If passed in, component will render the avatar image instead of the initials
     *
     * Required if "name" is not specified.
     */
    avatarUrl: PropTypes.string,

    /** classname to add to the container element. */
    className: PropTypes.string,

    /** Users id */
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

    /**
     * Users full name.
     *
     * Required if "avatarUrl" is not specified.
     */
    name: PropTypes.string
};


export default Avatar;
import PropTypes from 'prop-types';